import { Modal, ScrollArea } from '@mantine/core';

import { AbstractSync } from '@/module/Author/Abstract/AbstractSync';
import { ArticleSync } from '@/module/Author/Article/ArticleSync';
import { BookSync } from '@/module/Author/Book/BookSync';
import { ChapterSync } from '@/module/Author/Chapter/ChapterSync';
import { ProceedingSync } from '@/module/Author/Proceeding/ProceedingSync';
import { ImportEntityType, ImportItem } from '@/module/Sync/model/SyncTypes';

interface SyncModalProps {
  item: ImportItem;
  type: ImportEntityType;
  close: () => void;
  onSuccess: () => void;

  sourceType: string;
}

export function SyncModal({ item, type, close, onSuccess, sourceType }: SyncModalProps) {
  return (
    <Modal
      size="85%"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <ScrollArea h="70vh">
        {type === 'ARTICLE' && (
          <ArticleSync
            item={item}
            onSuccess={onSuccess}
            onCancel={close}
            sourceType={sourceType}
          />
        )}
        {type === 'BOOK' && (
          <BookSync
            item={item}
            onSuccess={onSuccess}
            onCancel={close}
            sourceType={sourceType}
          />
        )}
        {type === 'PROCEEDING' && (
          <ProceedingSync
            item={item}
            onSuccess={onSuccess}
            onCancel={close}
            sourceType={sourceType}
          />
        )}
        {type === 'CHAPTER' && (
          <ChapterSync
            item={item}
            onSuccess={onSuccess}
            onCancel={close}
            sourceType={sourceType}
          />
        )}
        {type === 'ABSTRACT' && (
          <AbstractSync
            item={item}
            onSuccess={onSuccess}
            onCancel={close}
            sourceType={sourceType}
          />
        )}
      </ScrollArea>
    </Modal>
  );
}
